<template>
  <div class="faq">
    <div class="header-operation">
      <Button type="primary" :loading="batchShelfLoading" @click="batchShelf">上架</Button>
    </div>
    <Modal v-model="modalTagAdd" title="选择标签" :closable="false" :mask-closable="false" @on-ok="updateTags" @on-cancel="cancelTags">
      <p>款式标签：</p>
      <Select v-model="updateTagsType" filterable>
        <Option v-for="item in dataTypeTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
      </Select>
      <p>风格标签一：</p>
      <Select v-model="updateTagsStyleFirst" filterable>
        <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
      </Select>
      <Button type="primary" style="margin-top: 10px; margin-bottom: 10px;" @click="isShowTagTwo =!isShowTagTwo">风格标签二</Button>
      <p v-if="isShowTagTwo">风格标签二：</p>
      <Select v-if="isShowTagTwo" v-model="updateTagsStyleSeconds" filterable>
        <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
      </Select>
      <p>备注：款式标签必选一个,风格标签可选择0/1/2个</p>
    </Modal>
    <Table :loading ='loading' stripe border highlight-row :columns="columns" :data="changeDataList" :height="tableHeight">
      <template slot-scope="{ row, index }" slot="title">
        <template v-if="editIndex === index">
          <Input v-model="updateTitle" placeholder="请输入商品名称" />
        </template>
        <span v-else>{{ row.title || '' }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="level">
        <template v-if="editIndex === index">
          <Select v-model="updateLevel" filterable style="width: 75px;" placeholder='等级'>
            <Option v-for="item in filterLevel" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.level | getLevel }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="url">
        <Poptip trigger="hover" :transfer="true" title="图片详情">
          <div class="info-pop" slot="content">
            <img :src="row.url">
          </div>
          <img :src="row.url" style="width: 86px;height: 86px;">
        </Poptip>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <span>{{ row.category_id|getClassify }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="images">
        <span class="images-text">{{ row.images_str }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="sex">
        <span>{{ row.sex|getSex }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateJewelPrice" />
        </template>
        <span v-else>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateCoinPrice" />
        </template>
        <span v-else>{{ row.coin_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
<!--        <template v-if="editIndex === index">-->
<!--          <Select v-model="updateStatus" filterable style="width:70px;" placeholder='状态'>-->
<!--            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
<!--          </Select>-->
<!--        </template>-->
<!--        <span v-else>{{ row.status|getStatus }}</span>-->
        <span>{{ row.status|getStatus }}</span>

      </template>

      <template slot-scope="{ row, index }" slot="tags">
        <template v-if="editIndex === index">
          <span class="images-text">{{ row.tags|getTagsEdit }}</span>
        </template>
        <span v-else class="images-text">{{ row.tags|getTags }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <div>
          <div v-if="editIndex === index" style="display: flex;">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button style="margin-left: 10px" @click="handleCanCel(index)" :disabled="action_btn_disabled">取消</Button>
          </div>
          <div v-else>
            <Button @click="handleEdit(row, index)">修改</Button>
            <Button style="margin-left: 10px" @click="showSelectTags(row, index)">标签</Button>
          </div>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";

export default {
  name: "faq",
  data() {
    return {
      tableHeight: 400,

      filterDiscount: [{
        label: '可打折',
        value: 1
      }, {
        label: '不可打折',
        value: 0
      }],
      filterStatus: [{
        label: '正常',
        value: 0
      }, {
        label: '下架',
        value: -1
      }, {
        label: '赠品',
        value: -2
      }],
      filterClassify: [{
        label: '表情',
        value: 1
      }, {
        label: '刘海',
        value: 2
      }, {
        label: '发型',
        value: 3
      },
        {
          label: '上装',
          value: 4
        }, {
          label: '下装',
          value: 5
        }, {
          label: '袜子',
          value: 6
        },
        {
          label: '鞋子',
          value: 7
        }, {
          label: '头饰',
          value: 8
        }, {
          label: '耳环',
          value: 9
        },
        {
          label: '脸部饰品',
          value: 10
        }, {
          label: '项链',
          value: 11
        }
      ],
      filterLevel: [{
        label: 'SSS',
        value: 10
      },
        {
          label: 'SS',
          value: 9
        },
        {
          label: 'S',
          value: 8
        },
        {
          label: 'A',
          value: 7
        },
        {
          label: 'B',
          value: 6
        },
        {
          label: 'C',
          value: 5
        },
        {
          label: 'D',
          value: 4
        },
        {
          label: 'E',
          value: 3
        },
        {
          label: 'F',
          value: 2
        },
        {
          label: 'G',
          value: 1
        }
      ],
      filterSex: [{
        label: '女',
        value: 0
      }, {
        label: '男',
        value: 1
      }, {
        label: '全部',
        value: -1
      }],
      data: [],

      action_btn_disabled: false,
      update_question: "",
      update_answer: "",
      update_faq_id: null,
      editIndex: -1,

      updateJewelPrice: null,
      updateCategoryId: -1,
      updateTitle: '',
      updateLevel: null,
      updateCoinPrice: null,
      updateStatus: 0,
      modalTagAdd: false,
      updateTagsIndex: -1,
      dataTypeTags: [],
      dataStyleTags: [],
      updateTagsPropId: -1,
      updateTagsType: 0,
      updateTagsStyleFirst: 0,
      updateTagsStyleSeconds: 0,
      isShowTagTwo: false,
      updateTagsArray: [],
      loading:false,
      batchShelfLoading: false, // 批量上架按钮加载状态
      passedRowData: null,  // 用于存储从父页面传递过来的数据
      columns: [{
        title: '缩略图',
        slot: 'url',
        width: 120,
        fixed: 'left',
      },
        {
          title: '类型',
          slot: 'category_id',
          width: 100
        },
        {
          title: '性别',
          slot: 'sex',
          width: 70
        },
        {
          title: '商品名称',
          slot: 'title',
          width: 150
        },
        {
          title: '等级',
          slot: 'level',
          key:'level',
          width: 95
        },
        {
          title: '用钻价格',
          slot: 'jewel_price',
          key:'jewel_price',
          width: 125
        },

        {
          title: '用币价格',
          slot: 'coin_price',
          width: 110
        },
        {
          title: '标签',
          slot: 'tags',
          key:'tags',
          width: 100
        },
        {
          title: '状态',
          slot: 'status',
          width: 110
        },
        {
          title: '图片',
          slot: 'images',
          width: 280
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          fixed: 'right',
        }
      ]
    }
  },
  async created() {
    this.tableHeight = window.innerHeight - 150
    window.addEventListener('resize', this.handleResize);

    this.initData()
  },
  watch: {
    // 如果退出编辑将多选框置为false
    editIndex: function(newVal, oldVal) {
      if (newVal === -1) {
        this.isUpdateTime = false
      }
    },

    modalTagAdd: function(newVal, oldVal) {
      if (newVal) {}
    }
  },
  methods: {
    handleResize() {
      this.tableHeight = window.innerHeight - 150
    },

    initData() {
      // 从路由参数中获取 shop_id 和 shop_title
      // 接收从父页面通过 localStorage 传递过来的数据并打印
      if (this.$route.query && this.$route.query.dataId) {
        const storedData = localStorage.getItem(this.$route.query.dataId);
        if (storedData) {
          console.log('从父页面传递过来的数据:', JSON.parse(storedData));
          // 可以在这里处理接收到的数据
          // 例如，将数据存储到组件的 data 中
          this.passedRowData = JSON.parse(storedData);
          // 使用完后删除 localStorage 中的数据，避免数据堆积
          localStorage.removeItem(this.$route.query.dataId);
          this.passedRowData?.clothes?.forEach((item, index) => {
            // console.log("test info item :  " + this.passedRowData?.sex??1)
            item.id = index + 1 // 临时数据
            item.type_tag_id = ''
            item.style_tag_ids = ''
            item.jewel_price = -1
            item.coin_price = -1
            item.title = ''
            item.tags = ''
            item.status = 0
            item.url =  `https://image.co-study.com.cn/app/image/figure/new_part/${item.images.shop??''}`
            item.sex = this.passedRowData?.sex ?? 1;
            // images 对象的value解析成用\n拼接的字符串 赋值给 images_str
            try {
              const imagesObj = item.images;
              if (typeof imagesObj === 'object' && imagesObj !== null) {
                item.images_str = Object.values(imagesObj).join('\n').replaceAll("girl/",'').replaceAll("boy/",'');
              } else {
                item.images_str = item.images;
              }
            } catch (e) {
              // 如果不是JSON格式，直接使用原值
              item.images_str = item.images;
            }
          })
          this.getRecords()
        } else {
          // 如果没有获取到数据，返回上一级页面
          // this.$Message.warning('无法获取页面数据，即将返回上一页');
          this.$router.go(-1); // 返回上一页
        }
      } else {
        // 如果没有传递 dataId 参数，也返回上一页
        this.$router.go(-1); // 返回上一页
      }
    },
    async getRecords() {
      this.loading = true
      this.data = this.passedRowData.clothes??[]
      this.loading = false
    },
    showSelectTags(row, index) {
      this.updateTagsPropId = row.id
      this.updateTagsType = 0
      this.updateTagsStyleFirst = 0
      this.updateTagsStyleSeconds = 0
      this.isShowTagTwo = false
      this.modalTagAdd = false
      this.dataStyleTags = []
      this.dataTypeTags = []
      this.updateTagsArray = row.tags.split(/[\s\n]/)
      this.updateTagsIndex = index
      this.getClothesTags(row.sex, row.category_id)
    },
    getClothesTags(prop_sex, prop_category_id) {
      let params = {
        'category_ids': prop_category_id,
        'sex': prop_sex,
      }
      apis.figure_shop_get_clothes_tags(params).then(res => {
        const {
          data,
          errCode,
          msg
        } = res;
        if (errCode === 0) {
          data.style_tags.unshift({
            'id': 0,
            'title': '空'
          })
          this.dataTypeTags = data.type_tags
          this.dataStyleTags = data.style_tags
          let hasType = false
          this.updateTagsArray.forEach(record => {
            if (typeof(record) === 'string' && record.length > 0) {
              this.dataTypeTags.forEach(item => {
                if (typeof(item.title) === 'string' && item.title.length > 0 && record === item.title) {
                  if (this.updateTagsType === 0) {
                    this.updateTagsType = item.id
                    hasType = true
                    return false
                  }
                }
              });
              if (hasType === true) {
                this.dataStyleTags.forEach(item => {
                  if (typeof(item.title) === 'string' && item.title.length > 0 && record === item.title) {
                    if (this.updateTagsStyleFirst === 0) {
                      this.updateTagsStyleFirst = item.id
                    } else if (this.updateTagsStyleSeconds === 0) {
                      this.updateTagsStyleSeconds = item.id
                    }
                  }
                });
              }
            }
          });
          this.modalTagAdd = true
        } else {
          this.$Message.error('获取标签列表失败');
        }
      }).catch(err => {
        this.$Message.error('获取标签列表失败');
      })
    },
    cancelTags(){
      this.updateTagsPropId = 0
      this.updateTagsType = 0
      this.updateTagsStyleFirst = 0
      this.updateTagsStyleSeconds = 0
      this.isShowTagTwo = false
      this.modalTagAdd = false
      this.dataStyleTags = []
      this.dataTypeTags = []
      this.updateTagsArray = []
      this.updateTagsIndex = -1
    },
    updateTags() {
      console.log("test info updateTagsPropId :  " + this.updateTagsPropId)
      console.log("test info updateTagsIndex :  " + this.updateTagsIndex)
      if (!this.updateTagsPropId > 0) {
        this.$Message.error('请选择商品!');
        this.cancelTags()
        return
      }
      if (this.updateTagsIndex < 0) {
        this.$Message.error('请选择商品');
        this.cancelTags()
        return
      }
      if (!this.updateTagsType > 0) {
        this.$Message.error('款式标签不能为空');
        this.cancelTags()
        return
      }
      // 当弹窗不展示风格标签二时，强制清除标签二的内容
      if(!this.isShowTagTwo){
        this.updateTagsStyleSeconds = 0
      }
      if (this.updateTagsStyleFirst != 0 && this.updateTagsStyleSeconds != 0 && this.updateTagsStyleFirst === this
          .updateTagsStyleSeconds) {
        this.$Message.error('风格标签一和风格标签二不能一样！');
        this.cancelTags()
        return
      }
      let styleTagIds = ""
      if (this.updateTagsStyleFirst === 0 && this.updateTagsStyleSeconds === 0) {

      } else if (this.updateTagsStyleFirst === 0 || this.updateTagsStyleSeconds === 0) {
        styleTagIds = this.updateTagsStyleFirst == 0 ? "" + this.updateTagsStyleSeconds : "" + this
            .updateTagsStyleFirst
      } else {
        styleTagIds = this.updateTagsStyleFirst + "," + this.updateTagsStyleSeconds
      }
      console.log("test info styleIds :  " + styleTagIds, this.updateTagsPropId, this.updateTagsType)
      // 本地更新

      let newTags = ''
      this.dataTypeTags.forEach(item => {
        if (typeof(item.title) === 'string' && item.title.length > 0 && item.id === this.updateTagsType) {
          newTags = item.title
        }
      });
      let firstTag =''
      let secondTag = ''
      this.dataStyleTags.forEach(item => {
        if (typeof(item.title) === 'string' && item.title.length > 0 ) {
          if(item.id !=0 && item.id === this.updateTagsStyleFirst){
            firstTag = item.title
          }
          if(item.id !=0 && item.id === this.updateTagsStyleSeconds){
            secondTag = item.title
          }
        }
      });
      if(newTags.length>0){
        if(firstTag.length>0){
          newTags = newTags + '\n'+ firstTag
        }
        if(secondTag.length>0){
          newTags = newTags + '\n'+ secondTag
        }
      }

      // 确保数组索引有效再进行赋值
      this.data[this.updateTagsIndex].tags = newTags
      this.data[this.updateTagsIndex].type_tag_id = this.updateTagsType > 0 ? this.updateTagsType.toString() : ''
      this.data[this.updateTagsIndex].style_tag_ids = styleTagIds
      // 强制触发响应式更新
      this.$set(this.data, this.updateTagsIndex, this.data[this.updateTagsIndex])
      this.$Message.success('标签设置成功！');
      this.cancelTags()
    },
    updateRecord(index) {
      this.data[this.editIndex].jewel_price = this.updateJewelPrice
      this.data[this.editIndex].coin_price = this.updateCoinPrice
      this.data[this.editIndex].title = this.updateTitle
      this.data[this.editIndex].level = this.updateLevel
      this.data[this.editIndex].status = this.updateStatus
      // 强制触发响应式更新
      this.$set(this.data, this.editIndex, this.data[this.editIndex])
      this.$Message.success('修改成功！');
    },

    handleEdit(row, index) {
      this.action_btn_disabled = false;
      this.updateTitle = row.title || '';
      this.updateLevel = row.level;
      this.updateJewelPrice = row.jewel_price;
      this.updateCoinPrice = row.coin_price;
      this.updateStatus = row.status;
      this.updateCategoryId = row.category_id;
      this.editIndex = index;
    },
    async handleSave(index) {
      if (!this.updateJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.updateCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
      if (this.updateLevel === null || this.updateLevel === undefined) {
        this.$Message.error('请选择等级');
        return
      }
      if (this.updateTitle && this.updateTitle.length > 0) {
        let params = {
          title: this.updateTitle ?? '',
        }
        let res =  await apis.figure_review_clothes_title_check(params)
        const {data, errCode, msg} = res;
        if (errCode === 0) {

        } else {
          this.$Message.error(msg);
          return;
        }
      } else if (this.updateCategoryId === 4) {
        this.$Message.error('上装必须填写商品名称');
        return
      }
      if (this.updateCoinPrice === -1 && this.updateJewelPrice === -1 && this.updateStatus === 0) {
        this.$Message.error('状态请选择下架或赠品')
        return
      }
      this.action_btn_disabled = true;
      this.updateRecord(index);
      this.editIndex = -1;
    },
    handleCanCel(index) {
      this.editIndex = -1
    },
    async batchShelf() {
      // 防抖：如果正在上架中，直接返回
      if (this.batchShelfLoading) {
        return;
      }
      
      this.batchShelfLoading = true; // 锁定按钮
      
      try {
        // 上架功能
        // 根据this.data 中的数据添加到以下clothes 中
        let clothes = []
        let errorMessage = '';
        let status = -9999;
        for(const item of this.data) {
          let it = {
            jewel_price: item.jewel_price,
            coin_price: item.coin_price,
            title: item.title,
            level: item.level,
            status: item.status,
            category_id: item.category_id,
            type_tag_id: item.type_tag_id,
            style_tag_ids: item.style_tag_ids,
            images: JSON.stringify(item.images)
          }
          console.log("test info status :  " + status, item.status)
          if (status !== -9999 && status !== item.status){
            errorMessage = `当前套装的所有商品的状态需一致`
            break
          }
          if(it.coin_price === -1 && it.jewel_price === -1 && it.status === 0){
            errorMessage = `${this.getCategoryName(item.category_id)}:当Co币Co钻价格都为-1时，只能标记为下架或赠品`
            break; // 遇到错误时中断循环
          }
          status = item.status
          clothes.push(it)
        }
        
        if (errorMessage) {
          this.$Message.error(errorMessage);
          return;
        }
        
        let post_data = {
          review_id: this.passedRowData.id,
          clothes: clothes
        }
        console.log("test info post_data :  " + JSON.stringify(post_data))
        
        // 发起上架请求
        const res = await apis.figure_review_clothes_status_putaway(post_data);
        const {data, errCode, msg} = res;
        if (errCode !== 0) {
          console.log("test info error :  " + msg)
          this.$Message.error(msg);
        } else {
          this.$Message.success('上架成功！');
          // 通知父组件刷新数据
          this.$parent.$emit('refresh-data', this.passedRowData.id);
          this.$router.go(-1); // 返回上一页
        }
      } catch (error) {
        console.error('上架失败:', error);
        this.$Message.error('上架失败，请重试');
      } finally {
        this.batchShelfLoading = false; // 解锁按钮
      }
    },
    getCategoryName(val) {
      let categoryClassifyMap = {
        1: '表情',
        2: '刘海',
        3: '发型',
        4: '上装',
        5: '下装',
        6: '袜子',
        7: '鞋子',
        8: '头饰',
        9: '耳环',
        10: '脸部饰品',
        11: '项链'
      }
      return categoryClassifyMap[val]
    },
    changeSelect() {
    }
  },
  computed: {
    changeDataList() {
      return this.data.map(item => {
        return item
      })
    }
  },
  filters: {
    getClassify(val) {
      let categoryClassifyMap = {
        1: '表情',
        2: '刘海',
        3: '发型',
        4: '上装',
        5: '下装',
        6: '袜子',
        7: '鞋子',
        8: '头饰',
        9: '耳环',
        10: '脸部饰品',
        11: '项链'
      }
      return categoryClassifyMap[val]
    },
    getLevel(val) {
      let levelMap = {
        0: '',
        1: 'G',
        2: 'F',
        3: 'E',
        4: 'D',
        5: 'C',
        6: 'B',
        7: 'A',
        8: 'S',
        9: 'SS',
        10: 'SSS'
      }
      return levelMap[val]
    },
    getSex(val) {
      if (val === 0) {
        return '女'
      } else {
        return '男'
      }
    },
    getDiscount(val) {
      if (val > 0) {
        return '可打折'
      } else {
        return '不可打折'
      }
    },
    getStatus(val) {
      if (val === 0) {
        return '正常'
      } else if (val === -1) {
        return '下架'
      } else if (val === -2) {
        return '赠品'
      } else {
        return '异常'
      }
    },
    getTags(val) {
      if (val === "") {
        return '暂无'
      } else {
        return val
      }
    },
    getTagsEdit(val) {
      if (val === "") {
        return '暂无'
      } else {
        return "\n\n\n\n\n\n" + val + "\n\n\n\n\n\n"
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.header-operation {
  margin-bottom: 10px;
  text-align: right;
}

.images-text {
  white-space: pre-wrap;
}
</style>